var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isLoading ? _c('div', [_c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  })], 1) : _c('div', {
    staticClass: "settings-app"
  }, [_c('OmniPageTitle', {
    attrs: {
      "title": _vm.$t('omt.gui.menu.label.settings'),
      "icon": "pe-7s-flag"
    }
  }), _c('OmniCard', {
    key: _vm.currentGroupIdentifier,
    scopedSlots: _vm._u([{
      key: "default",
      fn: function () {
        return [_c('BRow', [_c('BCol', {
          attrs: {
            "cols": "12",
            "lg": "2"
          }
        }, [_c('omni-sidebar', {
          attrs: {
            "items": _vm.groups
          }
        })], 1), _c('BCol', {
          staticClass: "parameters px-0",
          attrs: {
            "cols": "12",
            "lg": "10"
          }
        }, [_c('div', {
          staticClass: "inner-container"
        }, [_c('b-row'), _c('b-row', [_c('b-col', {
          attrs: {
            "cols": "12",
            "lg": "10"
          }
        }, [_c('OmniAlertInline', {
          staticClass: "mb-4",
          attrs: {
            "variant": "warning",
            "size": "sm"
          }
        }, [_vm._v(" Let op: Door onderstaande instellingen te wijzigen, wijzigt u dit voor alle gebruikers. ")])], 1), _c('b-col', {
          staticClass: "text-right",
          attrs: {
            "cols": "12",
            "lg": "2"
          }
        }, [_c('b-button', {
          attrs: {
            "disabled": !_vm.parametersChanged.length || _vm.isSaving,
            "variant": _vm.parametersChanged.length ? 'success' : 'light',
            "is-processing": _vm.isSaving,
            "icon": "save",
            "size": "lg"
          },
          on: {
            "click": _vm.save
          }
        }, [!_vm.isSaving ? _c('span', [_vm._v("Opslaan")]) : _c('font-awesome-icon', {
          attrs: {
            "icon": "spinner",
            "spin": ""
          }
        })], 1)], 1)], 1), _vm._l(_vm.currentGroupParameters, function (parameter) {
          return _c('b-row', {
            key: `group-${_vm.currentGroupIdentifier}-param-${parameter.key}`,
            staticClass: "mt-4",
            attrs: {
              "data-parameter-group": _vm.currentGroupIdentifier,
              "data-parameter-key": parameter.key
            }
          }, [_c('b-col', [_c('OmniCard', {
            staticClass: "mb-3 px-1 px-lg-2",
            class: {
              'border-warning': _vm.isParameterChanged(parameter)
            },
            scopedSlots: _vm._u([{
              key: "header",
              fn: function () {
                return [_c('b-card-title', {
                  staticClass: "mb-0"
                }, [_vm._v(_vm._s(_vm._f("uppercase")(_vm.$t(`frontend-parameters.parameters.${_vm.currentGroupIdentifier}.${parameter.key}.title`))))])];
              },
              proxy: true
            }, {
              key: "default",
              fn: function () {
                return [_vm.$t(`frontend-parameters.parameters.${_vm.currentGroupIdentifier}.${parameter.key}.description`) ? _c('p', [_c('i', {
                  domProps: {
                    "innerHTML": _vm._s(_vm.$t(`frontend-parameters.parameters.${_vm.currentGroupIdentifier}.${parameter.key}.description`))
                  }
                })]) : _vm._e(), !parameter.items ? _c('div', [_c('parameter-input', {
                  attrs: {
                    "parameter": parameter,
                    "parameter-group-identifier": _vm.currentGroupIdentifier
                  },
                  model: {
                    value: _vm.values[parameter.key],
                    callback: function ($$v) {
                      _vm.$set(_vm.values, parameter.key, $$v);
                    },
                    expression: "values[parameter.key]"
                  }
                })], 1) : _c('div', [parameter.groupType === 'generic' ? _c('parameter-generic-sub-group', {
                  attrs: {
                    "parameters": parameter.items,
                    "parameter-group-identifier": _vm.currentGroupIdentifier,
                    "sub-group-identifier": parameter.key
                  },
                  model: {
                    value: _vm.values[parameter.key],
                    callback: function ($$v) {
                      _vm.$set(_vm.values, parameter.key, $$v);
                    },
                    expression: "values[parameter.key]"
                  }
                }) : _vm._e()], 1)];
              },
              proxy: true
            }], null, true)
          })], 1)], 1);
        }), _c('div', {
          staticClass: "text-right mt-3"
        }, [_c('b-button', {
          attrs: {
            "disabled": !_vm.parametersChanged.length || _vm.isSaving,
            "variant": _vm.parametersChanged.length ? 'success' : 'light',
            "is-processing": _vm.isSaving,
            "icon": "save",
            "size": "lg"
          },
          on: {
            "click": _vm.save
          }
        }, [!_vm.isSaving ? _c('span', [_vm._v("Opslaan")]) : _c('font-awesome-icon', {
          attrs: {
            "icon": "spinner",
            "spin": ""
          }
        })], 1)], 1)], 2)])], 1)];
      },
      proxy: true
    }])
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }